<svelte:options accessors />

<script lang="ts">
	import { onMount } from 'svelte';
	import FormGroup from '../sub_components/FormGroup.svelte';
	import TextInputSub from './TextInputSub.svelte';
	import type { Component, Email } from '@prisma/client';
	import { KTIForm, type ServerDataValidation } from '../form';
	import { FormController } from '../actions';
	import * as Sentry from '@sentry/sveltekit';
	export let Valid = false;
	export let Value: string | null = null;
	export let Config: Email & Component;
	let emailComp: TextInputSub;
	let confirmComp: TextInputSub;
	const requiresCheck =
		Config.UseForParticipationCheck ||
		Config.UseForProductCheck ||
		Config.UseForSubmissionDupCheck ||
		Config.UseForInstanceCheck;
	let serverValidation: ServerDataValidation | null = requiresCheck
		? KTIForm.addServerValidation('email', Config.componentId)
		: null;
	export function doServerValidation() {
		if (serverValidation && typeof emailComp.Value == 'string') {
			//Check if email is duplicate or reject
			if (serverValidation.value && serverValidation.value.email == emailComp.Value) {
				return;
			}
			serverValidation.validate_value({ email: emailComp.Value });
		}
	}
	onMount(() => {
		confirmComp.OnValid = async () => {
			doServerValidation();
			const CenPOSComp = FormController.get_CenPOS_component()?.Comp;
			if (CenPOSComp) {
				CenPOSComp.setCustomerID(null, emailComp.Value);
			}
		};
	});
	export function appendData(formData: FormData) {
		console.log('getting formData from email');
		emailComp.appendData(formData);
	}
	// $: Valid = emailComp.Valid && confirmComp.Valid && emailComp.Value == confirmComp.Value ? true : false;
	// emailComp.Valid
	export async function validate() {
		console.log('validating emails', emailComp.Value, confirmComp.Value);
		await emailComp.validate();
		// if (emailComp.Value != confirmComp.Value) {
		// 	confirmComp.ErrorMsg = 'Emails do not match';
		// 	confirmComp.setInvalid();
		// }
		Valid = emailComp.Valid && emailComp.Value == confirmComp.Value ? true : false;
		if (Valid) {
			Value = emailComp.Value ? emailComp.Value : null;
		}
		return emailComp.Valid && emailComp.Value == confirmComp.Value;
	}
	export function focus() {
		if (emailComp.Valid && !confirmComp.Valid) {
			confirmComp.focus();
		} else {
			emailComp.focus();
		}
	}
	export function onChildValid() {
		Sentry.setUser({email: emailComp.Value || undefined}) // Set user.email tag in Sentry.io (search Sentry by email)
	}
</script>

<FormGroup {Config}>
	<div class="col" style="margin-bottom: -15px;">
		{#if Config.Title}
			<div class="comp-title">{Config.Title}</div>
		{/if}
	</div>
</FormGroup>
<FormGroup {Config}>
	<div class="col">
		<TextInputSub
			InsideTitle="Email"
			Validator="Email"
			AutoComplete="email"
			DBCol={Config.DBCol + 'email'}
			Required={Config.Required}
			Type="email"
			ShowCount={false}
			bind:this={emailComp}
			ConfirmEl={confirmComp}
			on:onValid={onChildValid}
		/>
	</div>
</FormGroup>
<FormGroup {Config}>
	<div class="col">
		<!-- <div class="form-outline" bind:this={emailOutlineEl}>
		<input
			class="form-control"
			id="email"
			type="email"
			autocomplete="email"
			name="email"
			required={Required}
		/>
		<label class="form-label" for="email">Email</label>
		<div class="invalid-tooltip" id="emailError" />
		<div class="msg-spacer" />
	</div> -->
		<TextInputSub
			InsideTitle="Confirm Email"
			Validator="Email"
			AutoComplete="email"
			DBCol={Config.DBCol + 'email_confirm'}
			Type="email"
			Required={Config.Required}
			ShowCount={false}
			bind:this={confirmComp}
			ConfirmWithEl={emailComp}
		/>
	</div>
</FormGroup>
<div class="multitext-spacer" />
